import React from 'react'
import { PlatformPlan } from 'Generated/graphql-types'

export const RESILIA_PRICING_URL = 'https://resilia.com/pricing'

export type PlanContent = {
  title: string
  Sell: React.ComponentType
  features: string[]
}

export type AllowedPlatformPlan = Exclude<
  PlatformPlan,
  | PlatformPlan.Enterprise
  | PlatformPlan.Plus
  | PlatformPlan.Pro
  | PlatformPlan.Advanced
>
const allowedPlatformPlans: string[] = Object.values(PlatformPlan).filter(
  (plan) => !['ENTERPRISE', 'ADVANCED', 'PLUS', 'PRO'].includes(plan)
)

export const isAllowedPlatformPlan = (
  plan: string
): plan is AllowedPlatformPlan => allowedPlatformPlans.includes(plan)

export const planContent: Record<AllowedPlatformPlan, PlanContent> = {
  [PlatformPlan.Starter]: {
    title: 'Nonprofit Platform — Starter',
    Sell: () => (
      <>
        Say goodbye to endless spreadsheets, expensive training, and frantic
        searches for program data and metrics.{' '}
        <strong>
          Say hello to seamless outcomes tracking, expert templates & tutorials,
          and your dedicated nonprofit coach with Resilia!
        </strong>
      </>
    ),
    features: [
      '100+ Academy Resources',
      'Create Goals',
      '3 Stories per Month',
      '3 Donations Campaigns',
      'Starter Community Spaces',
      'Up to 2 users',
    ],
  },
  [PlatformPlan.Performance]: {
    title: 'Nonprofit Platform — Performance',
    Sell: () => (
      <>
        Say goodbye to endless spreadsheets, expensive training, and frantic
        searches for program data and metrics.{' '}
        <strong>
          Say hello to seamless outcomes tracking, expert templates & tutorials,
          and your dedicated nonprofit coach with Resilia!
        </strong>
      </>
    ),
    features: [
      '250+ Academy Resources',
      'Unlimited Stories',
      'Unlimited Donations Campaigns',
      'Save 25 Funders in Funder Finder',
      'Performance Community Spaces',
      'Live Learning Events',
      'Unlimited Users',
      '2-Day Email Response Time',
    ],
  },
}
